/**
 * 페이지 나누기 블록 렌더/직렬화 (BlockNote `pageBreak`).
 * { type:"pageBreak", props:{}, content:[], children:[] }
 * 편집 화면=수평 구분선, 인쇄/PDF=페이지 구분.
 */

export function pageBreakBlockToElement(block) {
  if (typeof document === "undefined") throw new Error("pageBreakBlockToElement: DOM 필요");
  const el = document.createElement("div");
  el.className = "block";
  el.dataset.type = "pageBreak";
  if (block && block.id != null) el.dataset.id = String(block.id);
  el.__props = {};
  el.__children = [];

  const hr = document.createElement("div");
  hr.className = "lumir-page-break";
  hr.setAttribute("contenteditable", "false");
  hr.setAttribute("aria-label", "페이지 나누기");
  el.appendChild(hr);
  return el;
}

export function pageBreakElementToBlock(el) {
  const block = {};
  if (el.dataset.id != null) block.id = el.dataset.id;
  block.type = "pageBreak";
  block.props = {};
  // void 블록 → content 키 없음
  block.children = [];
  return block;
}
